var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$attrs.label)?_c('label',[_vm._v(_vm._s(_vm.$attrs.label))]):_vm._e(),_c('v-textarea',_vm._g(_vm._b({attrs:{"label":undefined,"solo":"","flat":"","outlined":""}},'v-textarea',_vm.$attrs,false),_vm.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }